cafm.rb.svc = {
    
    getRoomBookingServices: function () {

        var roomBooking = cafm.views.getMainFormViewModel();

        if (roomBooking.Services) {

            cafm.util.convertAllUTCToSessionDateTimes(roomBooking.Services, ['FromTime']);
        }
        else {

            roomBooking.set('Services', []);
        }

        var list = isFunc(roomBooking.Services.toJSON) ? roomBooking.Services.toJSON() : roomBooking.Services;

        return cafm.util.where(list, function (s) {

            return !cafm.util.isTrue(s.IsDeleted);
        });
    },
    getServiceRequestItems: function(){

        var serviceReq = cafm.rb.svc.getServiceRequestViewModel();

        return cafm.util.ensureValue(serviceReq.Items, []);
    },
    getServiceRequestViewModel: function () {

        var serviceReq = $('#editServiceReqFieldSet').getViewModel();

        // if this is null we assume this is an edit and the vm is bound to the whole action window
        if (isNullOrUndefined(serviceReq)) {

            serviceReq = cafm.views.getActionWindowViewModel();
        }

        return serviceReq;
    },
    handlers: {

        add: {

            add: function(){

                var roomBooking = cafm.views.getMainFormViewModel();

                if (!roomBooking.Services) {

                    roomBooking.Services = [];
                }

                var serviceReq = cafm.rb.svc.getServiceRequestViewModel();

                if (!cafm.rb.svc.helpers.ensureQuantities(serviceReq)) {

                    return;
                }
                
                // ensure correct date
                serviceReq.FromTime.setFullYear(roomBooking.StartDateTime.getFullYear());
                serviceReq.FromTime.setMonth(roomBooking.StartDateTime.getMonth(), roomBooking.StartDateTime.getDate());
                
                // add the service
                roomBooking.Services.push(serviceReq);

                // refresh services grid
                cafm.rb.svc.helpers.refreshServices();

                // close action form
                cafm.views.closeActionWindow();
            },
            cancel: function() {

                cafm.toolbar.standardActionToolbar.cancel();
            },
            gridItemDataBound: function (args) {

                if (!args.sender.element.data('initialising')) {

                    var data = args.sender.dataSource.data();
                    if (data && data.length == 1) {

                        var serv = data[0];
                        cafm.rb.svc.helpers.addService(serv);
                    }
                }

                args.sender.element.off('click.cafm').on('click.cafm', '.addLink', cafm.rb.svc.handlers.add.selectCatalogue);
            },
            init: function(){

                $('.winButtons .btn[data-key="Add"]').hide();
            },
            load: function (panel) {

                $('#catalogueFilters').bindViewModel($('#catalogueGrid').getCriteria());
                
                $('#catalogueSearchBtn').click(cafm.rb.svc.handlers.add.search);

                var tbox = panel.find('.searchDescription > .cfTextInput');

                var tboxSearchHandle = function () {

                    panel.find('.searchBtn').click();
                }

                // hook up enter pressed to the search btn
                tbox.enterPressed(tboxSearchHandle);

                // hookup auto complete select event to the search button
                tbox.data('autocompleteselect', tboxSearchHandle);
            },
            search: function () {

                var criteria = $('#catalogueFilters').getViewModel();

                $('#catalogueGrid').setCriteria(criteria).refreshGridDataSource();
            },            
            selectCatalogue: function (e) {

                var tr = $(e.currentTarget).parents('tr:first');
                var grid = $('#catalogueGrid').getGrid().data('kendoGrid');

                if (grid) {

                    var cata = grid.dataItem(tr);

                    if (cata) {

                        cafm.rb.svc.helpers.addService(cata);
                    }
                }
            },
        },
        editService: function (args) {

            var tr = $(args.currentTarget).parents('tr:first');
            var grid = $('#serviceGrid').getGrid().data('kendoGrid');

            if (grid) {

                var serv = grid.dataItem(tr);

                if (serv) {

                    cafm.views.openActionWindow({
                        url: cafm.url.get('RoomBooking/EditServiceRequest/{0}', serv.ID),
                        method: 'GET',
                        isForm: true,
                        viewModel: cafm.util.clone(serv),
                        winOptions: {
                            width: 600,
                            height: 450
                        },
                        onLoad: cafm.rb.svc.handlers.form.load
                    });
                }
            }
        },
        edit: {

            ok: function () {

                var serv = cafm.rb.svc.getServiceRequestViewModel();

                cafm.rb.svc.helpers.updateService(serv);
            },
            cancel: function () {

                cafm.views.closeActionWindow();
            }
        },
        form: {

            itemGridDataBound: function(args) {

                args.sender.element.find('.gridNumeric').each(function (i, el) {

                    $(el).attr('tabindex', 202 + i).kendoNumericTextBox({
                        min: 0,
                        max: 999999999,
                        format: 'n0',
                        decimals: 0,
                        change: cafm.rb.svc.handlers.form.quantityChanged
                    });
                });

                var total = args.sender.dataSource.total();
                var winButtons = args.sender.element.closest('.actionWindow').find('.winButtons');
                winButtons.find('[data-key="Add"]').attr('tabindex', 202 + total);
                winButtons.find('[data-key="Cancel"]').attr('tabindex', 203 + total);
            },
            load: function (panel) {

                var actionForm = cafm.views.getActionForm();
                var roomBooking = cafm.views.getMainFormViewModel();
                var serv = cafm.rb.svc.getServiceRequestViewModel();

                var enableTimeFields = function (flag) {

                    var tps = actionForm.getTimePickers();

                    if (cafm.util.hasItem(tps)) {

                        tps.forEach(function (tp) {

                            tp.enable(flag);
                        });
                    }
                }

                if (serv.UseMeetingTimes) {

                    enableTimeFields(false);
                }

                serv.bind('change', function (args) {

                    var sr = isObj(args.sender.source) ? args.sender.source : args.sender;

                    if (args.field == 'UseMeetingTimes') {

                        enableTimeFields(!sr.UseMeetingTimes);
                    }

                    if (args.field != 'FromTime' && sr.UseMeetingTimes) {

                        serv.set('FromTime', roomBooking.StartDateTime);
                    }
                });

                $('.winButtons .btn[data-key="Add"]').show();
            },
            quantityChanged: function (args) {

                var grid = $('#serviceRequestItemGrid').getGrid().data('kendoGrid');

                if (grid) {

                    var numeric = args.sender.element;
                    var tr = numeric.parents('tr:first');
                    var svcItem = grid.dataItem(tr);
                    
                    if (svcItem) {

                        svcItem.set('Quantity', args.sender.value());
                    }
                }
            }
        },
        removeService: function(args) {

            var tr = $(args.currentTarget).parents('tr:first');
            var grid = $('#serviceGrid').getGrid().data('kendoGrid');

            if (grid) {

                var serv = grid.dataItem(tr);

                if (serv) {

                    cafm.rb.svc.helpers.removeService(serv);
                }
            }
        },
        serviceGridItemDataBound: function (args) {
            
            var rb = cafm.views.getMainFormViewModel();

            if (!rb.IsReadOnly) {

                args.sender.element.off('click.cafm').on('click.cafm', '.removeLink', cafm.rb.svc.handlers.removeService);
                args.sender.element.on('click.cafm', '.editLink', cafm.rb.svc.handlers.editService);
            }
        }
    },
    helpers: {

        addService: function (cata) {

            var roomBooking = cafm.views.getMainFormViewModel();

            var exists = cafm.util.exists(roomBooking.Services.toJSON(), function (s) {

                return s.ID == cata.ID;
            });

            if (!exists) {
                
                $('#selectCatalogue').hide();

                $('#editService').loadView({
                    url: cafm.url.get('RoomBooking/NewServiceRequest/{0}', cata.ID),
                    onInit: cafm.rb.svc.handlers.form.init,
                    onLoad: cafm.rb.svc.handlers.form.load,
                    isForm: true
                }).show();
            }
        },
        ensureQuantities: function (serviceReq) {

            var valid = false;
            var gridDs = $('#serviceRequestItemGrid').getDataSource();

            gridDs.data().forEach(function (item) {

                var match = cafm.util.find(serviceReq.Items, function (tmpItem) {

                    return tmpItem.ID == item.ID;
                });

                if (match) {

                    match.set('Quantity', item.Quantity);

                    if (!valid && item.Quantity > 0) {

                        valid = true;
                    }
                }
            });

            if (!valid) {

                $('#editService').showMessage({

                    Type: cafm.enums.MessageType.Error,
                    Title: cafm.res.str.MessageAtLeaseOneServiceItem
                });
            }

            return valid;
        },
        quantityEditor: function (container, options) {

            $('<input required data-value-field="Quantity" data-bind="value: Quantity" class="cfControl gridNumeric"/>')
                .appendTo(container)
                .kendoNumericTextBox({
                    min: 0,
                    max: 10,
                    format: 'n0'
                });

        },
        quantityNumeric: function(quantity) {

            return '<input required class="cfControl gridNumeric" value="{0}" />'.format(quantity);
        },
        refreshServices: function () {

            $('#serviceGrid').refreshGridDataSource();
        },
        removeService: function (serv) {

            var roomBooking = cafm.views.getMainFormViewModel();
            var servOnBooking = cafm.util.find(roomBooking.Services, function (s) {

                return s.ID == serv.ID;
            });

            if (servOnBooking) {

                servOnBooking.set('IsDeleted', true);
            }

            cafm.rb.svc.helpers.refreshServices();
        },
        updateService: function (serv) {

            var roomBooking = cafm.views.getMainFormViewModel();
            var existing = cafm.util.find(roomBooking.Services, function (s) {

                return s.ID == serv.ID;
            });

            if (existing) {
                
                if (!cafm.rb.svc.helpers.ensureQuantities(serv)) {

                    return;
                }

                // ensure correct date
                serv.FromTime.setFullYear(roomBooking.StartDateTime.getFullYear());
                serv.FromTime.setMonth(roomBooking.StartDateTime.getMonth(), roomBooking.StartDateTime.getDate());
                
                // push onto existing item
                $.extend(existing, serv);

                // refresh services grid
                cafm.rb.svc.helpers.refreshServices();
            }

            cafm.views.closeActionWindow();
        }
    }
}